import { useRef, useState, useEffect } from 'react';
import { loadFacebook } from '@folklore/services';

import { useKey } from '../contexts/KeysContext';

const useFacebook = ({
    locale = 'fr_CA',
    version = 'v6.0',
    xfbml = false,
    autoLogAppEvents = true,
} = {}) => {
    const refFB = useRef(typeof window.FB !== 'undefined' ? window.FB : null);
    const [ready, setReady] = useState(refFB.current !== null);
    const facebookAppId = useKey('facebookAppId');
    useEffect(() => {
        let canceled = false;
        if (refFB.current === null) {
            loadFacebook({
                appId: facebookAppId,
                locale,
                version,
                xfbml,
                autoLogAppEvents,
            }).then((FB) => {
                if (!canceled) {
                    refFB.current = FB;
                    setReady(true);
                }
            });
        }
        return () => {
            canceled = true;
        };
    }, [facebookAppId, locale, version, xfbml, autoLogAppEvents, setReady]);
    return {
        ready,
        FB: refFB.current,
    };
};

export default useFacebook;
